import React from 'react';
import { Box } from '@mui/material';
import OnbTopBar from './OnbTopBar';
import brandCircle from '../../../assets/img/brand-circle.svg';
import brandDots from '../../../assets/img/brand-dots.svg';

/**
 * Screen frame of the onboarding: brand decoration, top bar with the stepper
 * and the screen content. On mobile the dots ring is dropped and only the blob
 * is kept, to preserve legibility (see the handoff's mobile notes).
 */
export default function OnbFrame({ children, step, exitLabel, decor = true, maxWidth = 1180 }) {
    return (
        <Box
            sx={{
                position: 'relative',
                minHeight: '100vh',
                overflow: 'hidden',
                backgroundColor: '#fff',
                display: 'flex',
                flexDirection: 'column'
            }}
        >
            {decor && (
                <Box aria-hidden sx={{ position: 'absolute', inset: 0, pointerEvents: 'none', overflow: 'hidden' }}>
                    <Box
                        component="img"
                        src={brandCircle}
                        alt=""
                        sx={{
                            position: 'absolute',
                            right: { xs: -360, md: -410 },
                            top: { xs: -280, md: -300 },
                            width: { xs: 420, md: 640 },
                            height: { xs: 420, md: 640 }
                        }}
                    />
                    <Box
                        component="img"
                        src={brandDots}
                        alt=""
                        sx={{
                            display: { xs: 'none', md: 'block' },
                            position: 'absolute',
                            top: '50%',
                            left: -427,
                            width: 475,
                            height: 475,
                            transform: 'translateY(-50%)'
                        }}
                    />
                </Box>
            )}

            <Box sx={{ position: 'relative', zIndex: 1, display: 'flex', flexDirection: 'column', flex: 1 }}>
                <OnbTopBar step={step} exitLabel={exitLabel} />

                <Box
                    component="main"
                    sx={{
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        width: '100%',
                        maxWidth,
                        mx: 'auto',
                        px: { xs: 2.5, md: 5 },
                        pb: { xs: 5, md: 6 }
                    }}
                >
                    {children}
                </Box>
            </Box>
        </Box>
    );
}
